<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  }
}
</script>
<style lang="less">
@import url('./styles/style.less');
</style>